export enum PayableCategory {
  ACCOUNT = "account",
  INVOICE = "invoice",
  ORDER = "order",
  // add more as needed
}
